import { render, staticRenderFns } from "./TransactionInventory.vue?vue&type=template&id=05cb8cf6"
import script from "./TransactionInventory.vue?vue&type=script&lang=js"
export * from "./TransactionInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports